import { createSlice } from "@reduxjs/toolkit";
import { mail_threads } from "../../../../types/mail/thread";

export const mailThread = createSlice({
  name: "mail_thread",
  initialState: {
    value: {
      status: false,
      data: [] as mail_threads,
    },
  },
  reducers: {
    update_thread: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_thread: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    remove_thread: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_thread: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_thread: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_thread,
  add_thread,
  remove_thread,
  replace_thread,
  clear_thread,
} = mailThread.actions;

export default mailThread.reducer;
